// env config
const origin = window.location.origin;
let baseUrl: string | undefined = "";

if (origin.includes("localhost")) {
    baseUrl = process.env.REACT_APP_API_HOST;
} else {
    baseUrl = origin;
}

const clientCredentials: string = btoa(
    process.env.REACT_APP_CLIENT_CREDENTIALS_INTERNAL || ""
);

export const Config = {
    apiUrl: baseUrl,
    // oAuthService: 'oauth2-service/',
    clientCredentialInternal: clientCredentials,
    oAuthService: "oauth2-service/",
    userService: "users-service/",
    userServiceRestApiV1: "users-service/v1/",
    therapySessionService: "therapy-sessions-service/",
    questionnaireService: "questionnaires-service/",
    practiceService: "practice-service/",
    matchService: "matches-service/",
    loggingService: "logging-service/",
    ticketService: "ticket-service/",
    therapysessionservieces: "therapy-sessions-service",
    questionnaireResponses: "question-responses",
    therapySessions: "therapy-sessions/",
    tokenService: "token-service/",
    ehrConnectService: "ehr-connect-service/",
    calenderService: "calendar-service/",
    configurationService: "configuration-service/",
};

export const GrantType = {
    CLIENT_CREDENTIALS: process.env.REACT_APP_CLIENT_CREDENTIALS,
};

export const Practice = {
    id: process.env.REACT_APP_PRACTICE_ID,
};

export const UserServiceSection = {
      profile_display : "PROFILE_DISPLAY",
};